/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ParameterConstraintForRegexPattern extends models.ParameterConstraintBaseForString {
    constructor() {
        super();
        this.setDiscriminator("ParameterConstraintForRegexPattern");
    }

    getFixupPrototypeFunction() { return ParameterConstraintForRegexPattern.fixupPrototype; }

    static newInstance(model: Partial<ParameterConstraintForRegexPattern>): ParameterConstraintForRegexPattern {
        let obj = Object.assign(new ParameterConstraintForRegexPattern(), model);
        ParameterConstraintForRegexPattern.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ParameterConstraintForRegexPattern>): ParameterConstraintForRegexPattern {
        if (!model) return null;
        return ParameterConstraintForRegexPattern.newInstance(<ParameterConstraintForRegexPattern> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ParameterConstraintForRegexPattern) {
        if (!obj) return;

        models.ParameterConstraintForRegexPattern.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ParameterConstraintForRegexPattern): boolean {
        if (models.ParameterConstraintBaseForString.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ParameterConstraintForRegexPattern.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * RegEx pattern for the value of the parameter
     */
    allowed_pattern: string;

}
